import React, { useEffect, useRef } from 'react'
import { ReactComponent as ArrowNotification } from '../../../../assets/arrow_notification.svg'
import { COLORS } from '../../../../styles/colors'
import { TypographyPrimary16Bold } from '../../../../ui/typography/TypographyPrimary16Bold'
import { MIN_YEAR } from '../../constants/constants'
import { YearPickerProps } from '../../types'
import { generateYearRange } from '../../utils/dateCalculations'
import {
	Header,
	StyledYearPicker,
	YearItem,
	YearList,
} from './YearPicker.styles'

/**
 * Компонент выбора года
 * Отображает скроллируемый список годов (текущий год ± 50 лет)
 * Автоматически скроллит к выбранному году при монтировании
 */
const YearPicker: React.FC<YearPickerProps> = ({
	selectedYear,
	onSelectYear,
	onBack,
}) => {
	const yearListRef = useRef<HTMLDivElement>(null)
	const selectedYearRef = useRef<HTMLButtonElement>(null)
	const years = generateYearRange(selectedYear).filter(year => year >= MIN_YEAR)

	// Автоматический скролл к выбранному году при монтировании
	useEffect(() => {
		if (selectedYearRef.current && yearListRef.current) {
			const yearList = yearListRef.current
			const selectedYearElement = selectedYearRef.current

			// Центрируем выбранный год в списке
			const listHeight = yearList.clientHeight
			const yearTop = selectedYearElement.offsetTop
			const yearHeight = selectedYearElement.clientHeight

			yearList.scrollTop = yearTop - listHeight / 2 + yearHeight / 2
		}
	}, [])

	return (
		<StyledYearPicker>
			<Header>
				<ArrowNotification
					onClick={onBack}
					style={{
						width: 24,
						height: 24,
						color: COLORS.icon,
						cursor: 'pointer',
					}}
				/>
			</Header>

			<YearList ref={yearListRef}>
				{years.map(year => {
					const isSelected = year === selectedYear

					return (
						<YearItem
							key={year}
							ref={isSelected ? selectedYearRef : null}
							onClick={() => onSelectYear(year)}
						>
							<TypographyPrimary16Bold
								style={{
									color: isSelected ? COLORS.main : COLORS.black,
								}}
							>
								{year}
							</TypographyPrimary16Bold>
						</YearItem>
					)
				})}
			</YearList>
		</StyledYearPicker>
	)
}

export default YearPicker
